export enum PathName {
  About = '/settings/about',
  AccountInformation = '/account-settings/account-information',
  AccountSettings = '/account-settings',
  AddMeasurement = '/add-measurement',
  AIAssistantChat = '/ai-assistant-chat',
  Allergies = '/health-profile/allergies',
  Appointment = '/appointment',
  AppointmentRequired = '/appointment-required',
  BillingDetails = '/account-settings/billing-details',
  ChangePassword = '/account-settings/change-password',
  Checkout = '/checkout',
  ChronicDiseases = '/health-profile/chronic-diseases',
  ConfirmAccount = '/confirm-account',
  ConfirmOrder = '/confirm-order',
  CreateAppointment = '/create-appointment',
  CreateFreeAccount = '/create-free-account',
  CreateNewPassword = '/create-new-password',
  CurrentWeight = '/current-weight',
  DeviceStatus = '/device-status',
  DiscountCard = '/my-prescriptions/discount-card',
  Documents = '/documents',
  ForgotPassword = '/forgot-password',
  GetCare = '/get-care',
  HealthConditions = '/health-profile/health-conditions',
  HealthMetrics = '/health-profile/health-metrics',
  HealthProfile = '/health-profile',
  HipaaAgreement = '/settings/hipaa-agreement',
  History = '/history',
  Home = '/',
  Insurance = '/account-settings/insurance',
  // HowToUseDevices = '/how-to-use-devices',
  IntakeForm = '/intake-form',
  IntakeFormMensTRT = '/intake-form-mens-trt',
  Join = '/join',
  Labs = '/labs',
  Legal = '/settings/legal',
  Login = '/login',
  ManageMedication = '/my-prescriptions/medication',
  MedicaidWaiver = '/settings/medicaid-waiver',
  MedicalIntakeForm = '/health-profile/medical-intake-form',
  MedicalRecords = '/health-profile/medical-records',
  MedicareConversion = '/medicare-conversion',
  MedicationConfirmation = '/medication-confirmation',
  Medications = '/health-profile/medications',
  MensTRT = '/mens-trt',
  MentalHealth = '/mental-health',
  Messages = '/messages',
  MigrateToBundlePlan = '/migrate-to-bundle-plan',
  MigrateToPlan = '/migrate-to-plan',
  // MigrateToCareOnlyPlan = '/migrate-to-care-only-plan',
  MigrateToTT = '/migrate-to-tt',
  MigrateToWM = '/migrate-to-wm',
  MoveFromSemaglutide = '/move-from-semaglutide',
  MoveFromTirzepatide = '/move-from-tirzepatide',
  MyPrescriptions = '/my-prescriptions',
  MyResources = '/my-resources',
  // MissingDataWMDevices = '/missing-data',
  NotFound = '/not-found',
  Notifications = '/account-settings/notifications',
  NotificationsFeed = '/notifications',
  PartnerBenefit = '/partner-benefit',
  PaymentMethods = '/payment-methods',
  Pharmacy = '/my-prescriptions/pharmacy',
  PostOnboarding = '/wm-adv-1-intake-form',
  PostOnboardingWH = '/wh-post-onboarding',
  Prescriptions = '/prescriptions',
  ReonboardingSummary = '/summary',
  SelectPrescriptions = '/select-prescriptions',
  Settings = '/settings',
  Shop = '/shop',
  ShopAddress = '/shop/address',
  ShopCart = '/shop/cart',
  ShopCheckout = '/shop/checkout',
  ShopOrders = '/shop/orders',
  ShopPrescriptionIntake = '/shop/prescription-intake',
  ShopProducts = '/shop/products',
  ShopSubscriptions = '/shop/subscriptions',
  SignInAndSecurity = '/account-settings/sign-in-and-security',
  SignUp = '/signup',
  SocialHistory = '/health-profile/social-history',
  Support = '/settings/support',
  Survey = '/survey',
  UnpaidInvoice = '/unpaid-invoice',
  UnsupportedAge = '/unsupported-age',
  UpgradePlan = '/upgrade-plan',
  UploadDocuments = '/upload-documents',
  VerifyEmail = '/verify/email',
  VerifyIdentity = '/verify-identity',
  VerifyYourIdentity = '/verify-your-identity',
  Weight = '/weight',
  WomensHealth = '/health-profile/womens-health',
  WomensHRT = "/women's-hrt",
  WorkOSCallback = '/auth/workos/callback',
  ZoomCall = '/zoom-call'
}
